import { Component, OnInit } from '@angular/core';
import { ArticleService } from '../../../services/article.service';
import { CArticle } from '../../../models/article.models/article.model';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'articleDetails',
    templateUrl: 'articleDetails.component.html',
})
export class ArticleDetailsComponent implements OnInit {
    ngOnInit(): void {
        this.GetArticle();
    }

    ApiServiceAddress: string;
    article: CArticle = new CArticle();
    id: number;

    constructor(private articleService: ArticleService, private route: ActivatedRoute, private location: Location, private titleService: Title, private metaService: Meta) {
        this.ApiServiceAddress = API_ServerAddress;
        this.id = +this.route.snapshot.paramMap.get('id');
    }

    GetArticle() {
        this.articleService.GetById(this.id)
            .subscribe((data: CArticle) => {
                this.article = data;
                this.SetPageMetaData(data);
            });
    }

    goBack(): void {
        this.location.back();
    }

    SetPageMetaData(model: CArticle) {
        this.titleService.setTitle(model.fSubject);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }
}